"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsMemberCertified = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var hsPingAnRegister_1 = require("../../model/hsPingAnRegister");
var service_1 = require("../../../library/base/service");
var IsMemberCertified = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(IsMemberCertified, _super);
    function IsMemberCertified() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '判断恒生是否注册认证';
        _this.code = '105021';
        _this.desc = '判断恒生是否注册认证';
        _this.requestParams = new hsPingAnRegister_1.IsMemberCertifiedRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return IsMemberCertified;
}(service_1.BaseService));
exports.IsMemberCertified = IsMemberCertified;
//# sourceMappingURL=isMemberCertified.js.map